import { render, staticRenderFns } from "./HiwAccordion.vue?vue&type=template&id=46f9f5ab&scoped=true&"
import script from "./HiwAccordion.vue?vue&type=script&lang=js&"
export * from "./HiwAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f9f5ab",
  null
  
)

export default component.exports